import React, { forwardRef } from "react";
import { RadioGroup, FormControlLabel, Radio } from "@mui/material";
import ModalShell from "../../../../shares/dashboard/ModalShell";

/**
 * Read-only breakdown of one student's exam attempt: the score summary plus
 * their choice on each of the 10 questions. forwardRef for the MUI <Modal>
 * child ref; the radio groups stay disabled/non-interactive as before, just on
 * the shared shell with a token-based summary strip.
 */
const ExamInfo = forwardRef(({ close, data }, ref) => {
  const items = [...Array(10).keys()];
  const correct = 10 - (data.wrong_counts + data.none_counts);

  return (
    <ModalShell
      ref={ref}
      close={close}
      title={`آزمون ${data.exam.ExamName}`}
      subtitle={`نمره: ${Number(data.score).toLocaleString("fa-IR")}`}
    >
      <div className="mb-lg grid grid-cols-3 gap-sm">
        <div className="rounded-card border border-rule-subtle bg-surface-sunken px-md py-sm text-center">
          <p className="text-xs text-ink-subtle">صحیح</p>
          <p className="mt-2xs text-lg font-semibold tabular-nums text-success">
            {correct.toLocaleString("fa-IR")}
          </p>
        </div>
        <div className="rounded-card border border-rule-subtle bg-surface-sunken px-md py-sm text-center">
          <p className="text-xs text-ink-subtle">غلط</p>
          <p className="mt-2xs text-lg font-semibold tabular-nums text-danger">
            {Number(data.wrong_counts).toLocaleString("fa-IR")}
          </p>
        </div>
        <div className="rounded-card border border-rule-subtle bg-surface-sunken px-md py-sm text-center">
          <p className="text-xs text-ink-subtle">بی‌پاسخ</p>
          <p className="mt-2xs text-lg font-semibold tabular-nums text-ink-muted">
            {Number(data.none_counts).toLocaleString("fa-IR")}
          </p>
        </div>
      </div>

      <div className="flex flex-col divide-y divide-rule-subtle">
        {items.map((item, index) => (
          <RadioGroup
            key={item}
            className="!flex-row items-center justify-between py-xs"
            value={String(data.user_choice[index] ?? "")}
          >
            <span className="text-sm text-ink">
              سوال {(index + 1).toLocaleString("fa-IR")}
            </span>
            <span className="flex items-center">
              {["1", "2", "3", "4"].map((choice) => (
                <FormControlLabel
                  key={choice}
                  className="pointer-events-none"
                  value={choice}
                  control={<Radio size="small" />}
                  label={choice}
                />
              ))}
            </span>
          </RadioGroup>
        ))}
      </div>
    </ModalShell>
  );
});

export default ExamInfo;
